import { useContext } from "react";
import { TranslationContext } from "./LocalizationContext";

export const useTranslation = () => {
    return useContext(TranslationContext);
};
